import React from 'react';
import { RegisterItemList } from './RegisterItemList';

export const IncidentList: React.FC = () => {
  return (
    <RegisterItemList
      title="Incidents"
      iconClass="ri-alarm-warning-line"
      listPath="/incidents"
      detailPathPrefix="/incidents"
      configPath="/incident-config"
      registersPath="/incident-registers"
      idField="incidentId"
      titleField="incident_title"
      priorityField="incident_priority"
      statusField="incident_status"
      registerQueryParam="registerId"
    />
  );
};
